import { defineComponent, reactive } from 'vue';
import { MainTitle, ReportTabList } from '@/components';
import { GridContainer } from '@/containers';
export default defineComponent({
    name: 'Grid',
    components: {
        MainTitle,
        ReportTabList,
        GridContainer,
    },
    setup() {
        const state = reactive({
            tabname: 'hourly',
        });
        return { state };
    },
});
